import { ToastChakra } from "../helpers/toast";
import api from "../helpers/api";


const baseURL = process.env.REACT_APP_API_URL;

const getAllClientes = async (data) => {
    const {page, perPage} = data;
    const response = await api.get(`${baseURL}/cliente/listar?pagina=${page}&cantidadPagina=${perPage}`);
    //console.log('esto traigo en servicio clientes:', response.data);
    return response.data;  // Aquí obtienes el objeto con `data` y `pagination`
}


const createCliente = async (data) => {
    const response = await api.post(`${baseURL}/cliente/crear`, data);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('CLIENTE CREADO', 'El cliente se ha creado correctamente', 'success', 3000, 'bottom-right');
        return response.data;
    }
}

// Delete
const deleteCliente = async (id) => {

    const response = await api.delete(`${baseURL}/cliente/eliminar/${id}`);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('CLIENTE ELIMINADO', 'El cliente se ha eliminado correctamente', 'success', 3000, 'bottom-right');
        return response.data;
    }
}

// Update
const updateCliente = async (data) => {
    const response = await api.put(`${baseURL}/cliente/actualizar/${data.id}`, data);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('CLIENTE MODIFICADO', 'El cliente se ha modificado correctamente', 'success', 3000, 'bottom-right');
        return response.data
    }
}

const getClienteByDni = async (dni) => {
    const response = await api.get(`${baseURL}/cliente/buscar/${dni}`);
    if (response.status === 200 || response.status === 201) {
       // console.log('esto traigo en servicio buscarClientePorDni:', response.data);
        return response.data;
    }
}

const getSiguienteNroFactura = async () => {
    const response = await api.get(`${baseURL}/factura_venta/siguiente_nro_factura`);
     if (response.status === 200 || response.status === 201) {
      //  console.log('esto trae nroSiguiente :', response.data);
        return response.data;
     }
}


const getSiguienteNroPresupuesto = async () => {
    const response = await api.get(`${baseURL}/presupuesto/siguiente_nro_presupuesto`);
     if (response.status === 200 || response.status === 201) {
      //  console.log('esto trae nroSiguiente :', response.data);
        return response.data;
     }
}


const clienteService = {
    getAllClientes,
    createCliente,
    deleteCliente,
    updateCliente,
    getClienteByDni,
    getSiguienteNroFactura,
    getSiguienteNroPresupuesto
}

export default clienteService;